import { ApolloClient, InMemoryCache } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';
import { apolloLink } from '../../../shared/data/apolloClient';

const suspectsContentApolloClient = new ApolloClient({
  link: apolloLink,
  cache: new InMemoryCache({
    typePolicies: {
      Suspect: {
        fields: {
          attachments: relayStylePagination(),
          vehicles: relayStylePagination(),
        },
      },
      Organization: {
        fields: {
          suspects: relayStylePagination(),
        },
      },
    },
  }),
});

export default suspectsContentApolloClient;
